<template>
  <div class="row" v-if="filteredRosterList && $store.getters.currentUser" v-bind:class="{'wait': creationStarted }">
    <messageModal v-if="showMessage" message="votre équipe a été crée !" @closeMessage="goToDetail"></messageModal>
    <spinningModal v-if="showSpinner"></spinningModal>
    <div class="panel">
      <div class="panel-content">
        <div class="row columns">
          <div class="panel-title">
            Créez votre équipe !
          </div>
          <div class="row">
            <div class="large-9 large-centered note">
              Ajoutez ou supprimez des éléments avec les boutons + et - de fin de ligne.
            </div>
          </div>
          <hr>
          <br>
          <div class="row columns">
            <div class="large-12 columns">
              Type d'équipe
            </div>
            <div class="large-9 large-centered note" v-if="$store.getters.currentUser.is_superuser">
              En tant qu'admin vous pouvez rentrer des équipes customs, dont le budget n'est pas limité
            </div>
            <br>
            <div class="large-4 large-centered">
              <select name="" v-model="teamType">
                <option value="new">Nouvelle Equipe</option>
                <!--option v-if="$store.getters.currentUser.is_superuser" value="custom">Equipe Custom</option>
                <option value="newFranchise">Reprise de Franchise simple</option>
                <option value="franchise">Reprise de Franchise après intersaison</option-->
              </select>
            </div>
          </div>
          <br>
          <br>
          <div class="row" v-if="$store.getters.formatedClubList">
            <div class="large-3 columns">
              Club :
              <select v-model="chosenClub">
                <option v-for="club in $store.getters.formatedClubList" v-bind:value="club">
                  {{ club.name }}
                </option>
              </select>
            </div>
            <div class="large-3 columns" v-if="currentUser">
              Compétition :
              <select v-model="chosenLeague" v-if="chosenClub !== null"
                      :disabled="chosenClub === null">
                <option v-for="league in chosenClub.leagues" v-bind:value="league">
                  {{league.name}}
                </option>
              </select>
            </div>
            <div class="large-3 columns">
              <div>Saison :</div>
              <select v-model="chosenSeason" v-if="chosenLeague"
                      :disabled="chosenLeague === undefined">
                <option v-for="rg in chosenLeague.seasons" v-bind:value="rg">
                  {{rg.name}}
                </option>
              </select>
            </div>
            <div class="large-3 columns">
              <div>Poule :</div>
              <select v-model="chosenRankingGroup" v-if="chosenSeason"
                      :disabled="chosenSeason === undefined">
                <option v-for="rg in chosenSeason.ranking_groups" v-bind:value="rg">
                  {{rg.name}}
                </option>
              </select>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="large-2 columns">
              <div>Coach :</div>
              <input v-if="currentUser && currentUser.is_superuser === false" type="text" :value="currentUser.username"
                     disabled>
              <multiselect
                v-model="selectedCoach"
                :options="userList"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="true"
                :preserve-search="true"
                :show-labels="false"
                placeholder=""
                label="username"
                track-by="username"
                :preselect-first="false">
              </multiselect>
            </div>
            <template v-if="teamType==='new' || teamType==='custom'">
              <div class="large-3 columns">
                Roster :
                <select :disabled="!selectedRankingGroup" v-model="chosenRoster">
                  <option v-for="roster in filteredRosterList" v-bind:value="roster">
                    {{ roster.name }}
                  </option>
                </select>
              </div>
              <div class="large-3 columns">
                <div v-bind:class="{'error': !teamName }">Nom de l'équipe :</div>
                <input :disabled="!chosenRoster" v-model="teamName" type="text">
              </div>
              <div class="large-3 columns" v-if="currentUser">
                <div class="row">
                  <div class="large-8 large-centered columns">
                    <div>Icône</div>
                    <imageEditor ref="imgEditor" :imageSrc="'http://via.placeholder.com/640x400'"></imageEditor>
                  </div>
                </div>
              </div>
            </template>
            <franchiseChooser ref="franchiseChooser"
                              v-if="selectedClub"
                              v-show="teamType === 'newFranchise' || teamType === 'franchise'"
                              @franchiseSelected="updateFranchise"
                              :club="selectedClub.id"></franchiseChooser>
          </div>
          <div class="large-9 large-centered info" v-if="maxBudget && selectedRoster">
            <br>
            <template v-if="teamType==='new'">
              Vous disposez d'un Budget de {{maxBudget}} 000 pO pour créer votre nouvelle équipe
            </template>
            <template v-if="teamType==='custom'">
              Vous disposez d'un Budget illimité pour créer votre nouvelle équipe
            </template>
            <template v-if="teamType==='newFranchise' || teamType==='franchise'">
              Vous disposez d'un Budget de {{maxBudget}} 000 pO pour recréer les {{selectedFranchise.name}}
            </template>
            <br>
          </div>
          <div class="row columns">
            <div class="large-12">
              <div v-show="$store.getters.detailedRoster">
                <formerPlayerChooser ref="formerPlayerChooser"
                                     v-show="teamType === 'franchise' && selectedFranchise"
                                     :baseChosenLines="newlyHiredPlayers"
                                     :team="$store.getters.detailedTeam"></formerPlayerChooser>
                <baseTeamBuilder ref="teamBuilder"
                                 v-show="selectedRoster"
                                 :alreadyChosenLines="hiredFormerPlayerRosterLines"
                                 :roster="$store.getters.detailedRoster"></baseTeamBuilder>
                <template v-if="false">
                  <div class="row columns">
                    <div class="large-12 inner-title">
                      Engager un champion sur le long terme :
                    </div>
                    <div class="large-12 inner-subtitle">
                      Vous devrez payer la valeur du champion, puis un salaire après chaque match.
                      Adressez vous à votre commissaire de ligue pour plus de précisions
                    </div>
                  </div>
                  <table>
                    <thead>
                    <tr class="">
                      <th width="250">Nom</th>
                      <th width="10">M</th>
                      <th width="10">F</th>
                      <th width="10">Ag</th>
                      <th width="10">Ar</th>
                      <th width="390">Compétences</th>
                      <th with="150">coût</th>
                      <th width="20"></th>
                      <th width="20"></th>
                    </tr>
                    </thead>
                    <tbody class="roster" v-if="$store.getters.detailedRoster">
                    <tr>
                      <td class="action">
                        <select v-model="selectedStarPlayer"
                                :disabled="rosteredStarPlayer !== null"
                                class="starbox">
                          <option v-for="star of $store.getters.detailedRoster.star_players" v-bind:value="star">
                            {{ star.name }}
                          </option>
                        </select>
                      </td>
                      <td v-if="selectedStarPlayer">{{selectedStarPlayer.M}}</td>
                      <td v-else colspan="6">selectionnez une star</td>
                      <td v-if="selectedStarPlayer">{{selectedStarPlayer.F}}</td>
                      <td v-if="selectedStarPlayer">{{selectedStarPlayer.Ag}}</td>
                      <td v-if="selectedStarPlayer">{{selectedStarPlayer.Ar}}</td>
                      <td v-if="selectedStarPlayer">
                                            <span v-for="skill of selectedStarPlayer.skills">
                                                {{skill.name}},
                                            </span>
                      </td>
                      <td v-if="selectedStarPlayer">{{selectedStarPlayer.cost}} 000</td>
                      <td class="action">
                        <button v-bind:class="{ deactivated: rosteredStarPlayer !== null, action:true }"
                                v-on:click="rosteredStarPlayer = selectedStarPlayer">+
                        </button>
                      </td>
                      <td>
                        <button v-bind:class="{ deactivated: rosteredStarPlayer === null, action:true }"
                                v-on:click="rosteredStarPlayer = null">-
                        </button>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="6" class="sous-total right">Budget Star Player</td>
                      <td v-if="selectedStarPlayer" class="sous-total">{{selectedStarPlayer.cost}} 000</td>
                      <td v-else="selectedStarPlayer" class="sous-total">0</td>
                      <td colspan="2"></td>
                    </tr>
                    </tbody>
                  </table>
                </template>
                <template v-if="selectedRoster">
                  <div class="row columns">
                    <div class="large-12 inner-title">
                      Encadrement & Relances :
                    </div>
                    <div class="large-12 inner-subtitle">
                      Tout le reste. Ceux qui ont des corones jouent sans relance. Hein papy ?
                    </div>
                  </div>
                  <div class="row">
                    <div class="large-7 columns">
                      <table>
                        <tbody class="roster" v-if="$store.getters.detailedRoster">
                        <tr>
                          <td width="50"><img class="team-icon" src="/static/imgs/icons/dices.png" alt=""></td>
                          <td width="125">Relances</td>
                          <td width="110">{{$store.getters.detailedRoster.reroll_price}} 000</td>
                          <td width="70">{{nbRerolls}}</td>
                          <td width="150">{{nbRerolls * $store.getters.detailedRoster.reroll_price}} 000</td>
                          <td width="50" class="action">
                            <button @click="nbRerolls++" class="action">+</button>
                          </td>
                          <td v-if="nbRerolls>0" width="50">
                            <button class="action" @click="nbRerolls--">-</button>
                          </td>
                          <td v-else width="50">
                            <button class="deactivated action" disabled>-</button>
                          </td>
                        </tr>
                        <tr v-if="$store.getters.detailedRoster.apo_available == true">
                          <td><img class="team-icon" src="/static/imgs/icons/red-cross.png" alt=""></td>
                          <td>Apothicaire</td>
                          <td>50 000</td>
                          <td>{{apo}}</td>
                          <td>{{apo * 50}} 000</td>
                          <td v-if="apo==0" class="action">
                            <button @click="apo=1" class="action">+</button>
                          </td>
                          <td v-else class="action">
                            <button class="deactivated action">+</button>
                          </td>
                          <td v-if="apo==1">
                            <button @click="apo=0" class="action">-</button>
                          </td>
                          <td v-else>
                            <button class="deactivated action" disabled>-</button>
                          </td>
                        </tr>
                        <tr>
                          <td><img class="team-icon" src="/static/imgs/icons/glove.png" alt=""></td>
                          <td>Fans dévoués</td>
                          <td>10 000</td>
                          <td>{{pop}}</td>
                          <td>{{ (pop - 1) * 10}} 000</td>
                          <td v-if="pop < 6" class="action">
                            <button class="action" @click="pop++">+</button>
                          </td>
                          <td v-else width="50">
                            <button class="deactivated action" disabled>+</button>
                          </td>
                          <td v-if="pop > 1" width="50">
                            <button class="action" @click="pop--">-</button>
                          </td>
                          <td v-else width="50">
                            <button class="deactivated action" disabled>-</button>
                          </td>
                        </tr>
                        <tr>
                          <td><img class="team-icon" src="/static/imgs/icons/coach.png" alt=""></td>
                          <td>Assistants</td>
                          <td>10 000</td>
                          <td>{{assistants}}</td>
                          <td>{{assistants * 10}} 000</td>
                          <td class="action">
                            <button class="action" @click="assistants++">+</button>
                          </td>
                          <td v-if="assistants > 0" width="50">
                            <button class="action" @click="assistants--">-</button>
                          </td>
                          <td v-else width="50">
                            <button class="deactivated action" disabled>-</button>
                          </td>
                        </tr>
                        <tr>
                          <td><img class="team-icon" src="/static/imgs/icons/pom-pom.png" alt=""></td>
                          <td>Pom-pom girls</td>
                          <td>10 000</td>
                          <td>{{pompoms}}</td>
                          <td>{{pompoms * 10}} 000</td>
                          <td class="action">
                            <button class="action" @click="pompoms++">+</button>
                          </td>
                          <td v-if="pompoms > 0" width="50">
                            <button class="action" @click="pompoms--">-</button>
                          </td>
                          <td v-else width="50">
                            <button class="deactivated action" disabled>-</button>
                          </td>
                        </tr>
                        <tr>
                          <td class="sous-total right" colspan="3">Budget Annexe</td>
                          <td></td>
                          <td class="sous-total">{{budgetAnnexe}} 000</td>
                          <td colspan="2"></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <br>
          <div v-if="$store.getters.detailedRoster" class="row">
            <div class="team-value large-5 large-centered columns">
              Valeur totale de l'équipe :
              {{currentTeamBudget}} 000 piéces d'or
            </div>
          </div>
          <br>
          <div class="row">
            <div class="large-3 columns">
              <button class="light-grey-button">Annuler</button>
            </div>
            <div class="large-3 columns">
              <button @click="createTeam" class="">Valider</button>
            </div>
          </div>
          <br>
          <div v-if="errorMsg" class="row">
            <div class="large-12 large-centered columns text-centered">
              <div class="error text-centered">{{errorMsg}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <spinner></spinner>
  </div>
</template>

<script>
import store from '../../store/index.js'
import { mapGetters } from 'vuex'
import spinner from '../common/spinner.vue'
import imageEditor from '../common/image-editor.vue'
import team from '../../api/team.api'
import messageModal from '../common/message-modal.vue'
import spinningModal from '../common/spinning-modal.vue'
import franchiseChooser from './create/franchise-chooser'
import baseTeamBuilder from './create/base-team-builder'
import formerPlayerChooser from './create/former-player-chooser'
import Multiselect from 'vue-multiselect'
import teamPurchases from '../../api/team-purchases.api'
import teamExtraWinning from '../../api/extra-winnings.api'

export default {
  name: 'teamCreate',
  components: {
    spinner,
    messageModal,
    imageEditor,
    spinningModal,
    franchiseChooser,
    baseTeamBuilder,
    formerPlayerChooser,
    Multiselect
  },
  data () {
    return {
      teamName: '',
      apo: 0,
      pop: 1,
      nbRerolls: 0,
      assistants: 0,
      selectedRoster: null,
      pompoms: 0,
      errorMsg: null,
      showMessage: false,
      showSpinner: false,
      createdTeamId: 0,
      creationStarted: false,
      selectedCoach: null,
      selectedClub: null,
      selectedLeague: null,
      selectedSeason: null,
      selectedRankingGroup: null,
      selectedStarPlayer: null,
      rosteredStarPlayer: null,
      teamType: 'new',
      selectedFranchise: null,
      // variable d'état
      revokesDone: false,
      transfertDone: false,
      treasuryadjustmentDone: false,
      purchasesDone: false
    }
  },
  watch: {
    teamType: function (newType, oldType) {
      this.selectedClub = null
      this.selectedRoster = null
      this.selectedLeague = null
      this.selectedSeason = null
      this.selectedRankingGroup = null
      this.selectedFranchise = null
    },
    revokesDone: function (newValue, oldValues) {
      // ensuite on va faire le transfert de l'équipe dans une autre ligue
      if (newValue) {
        let patchedDatas = {
          'id': this.selectedFranchise.id,
          'league': this.chosenSeason.id,
          'ranking_group': this.selectedRankingGroup.id
        }
        console.log(patchedDatas)
        team.api.updateTeam(this.$store.getters.detailedTeam.id, patchedDatas)
          .then(response => {
            this.transfertDone = true
          },
          error => {
            console.log('impossible to transfert team')
            console.log(error)
          })
      }
    },
    transfertDone: function (newValue, oldValues) {
      // enfin on doit faire les achats qui manquent, joueurs et star, via l'api de customisation
      // et donc pour ça on ajoute la trésorerie nécéssaire
      if (newValue) {
        let missingTreasury = this.maxBudget - this.totalFormerPlayerCost - this.$store.getters.detailedTeam.treasury
        // les dépenses sont traités comme des achats, donc les rerolles coutent deux fois le prix
        missingTreasury += this.nbRerolls * this.selectedRoster.reroll_price
        let extraWinnings = {}
        extraWinnings.created_by = this.$store.getters.currentUser.id
        extraWinnings.amount = missingTreasury
        extraWinnings.team = this.$store.getters.detailedTeam.id
        teamExtraWinning.api.createExtraWinnings(extraWinnings)
          .then(response => {
            this.treasuryadjustmentDone = true
          },
          error => {
            console.log('erreur impossible to create extra winnings')
            console.log(error)
          })
      }
    },
    treasuryadjustmentDone: function (newValue, oldValues) {
      // on réalise les achats des nouveaux joueurs, de staff, et de stars
      let purchases = {}
      purchases.hire = {}
      // gestion du stuff
      if (this.apo === 1) {
        purchases.hire.apo = true
      }
      if (this.nbRerolls > 0) {
        purchases.hire.reroll = this.nbRerolls
      }
      if (this.assistants > 0) {
        purchases.hire.assistants = this.assistants
      }
      if (this.pompoms > 0) {
        purchases.hire.cheerleaders = this.pompoms
      }
      if (this.pop > 0) {
        purchases.hire.cheerleaders = this.pompoms
      }
      if (this.selectedStarPlayer !== null) {
        purchases.hire.star_player = {}
        purchases.hire.star_player.num = 0
        purchases.hire.star_player.ref_star_player = this.selectedStarPlayer.id
      }

      let candidateNum = Math.max(...this.$store.getters.detailedTeam.players.map(p => {
        return p.num
      })) + 1
      // gestion des nouveaux joueurs
      purchases.hire.players = this.$refs.teamBuilder.getPLayerArray().map(p => {
        p.name = ''
        p.num = candidateNum
        candidateNum = candidateNum + 1
        return p
      })

      console.log(purchases)
      teamPurchases.api.publishTeamPurchases(this.$store.getters.detailedTeam.id, purchases)
        .then(response => {
          this.purchasesDone = true
        },
        error => {
          console.log('erreur impossible to publish initial purchases')
          console.log(error)
        })
    },
    purchasesDone: function (newValue, oldValues) {
      if (newValue) {
        let datas = {}
        datas.status = 1
        team.api.updateTeam(this.$store.getters.detailedTeam.id, datas)
          .then(response => {
            this.$store.dispatch('reloadDetailedTeam')
            this.showMessage = true
            this.creationStarted = false
            this.showSpinner = false
            this.createdTeamId = this.$store.getters.detailedTeam.id
          }, error => {
            console.log('erreur impossible to activate purchase mode')
            console.log(error)
          })
      }
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'clubList',
      'userList'
    ]),
    chosenClub: {
      get: function () {
        return this.selectedClub
      },
      set: function (newSelectedClub) {
        this.selectedClub = newSelectedClub
        this.chosenLeague = newSelectedClub.leagues[newSelectedClub.leagues.length - 1]
      }
    },
    chosenLeague: {
      get: function () {
        return this.selectedLeague
      },
      set: function (newChosenLeague) {
        this.selectedLeague = newChosenLeague
        this.chosenSeason = newChosenLeague.seasons[newChosenLeague.seasons.length - 1]
      }
    },
    chosenSeason: {
      get: function () {
        return this.selectedSeason
      },
      set: function (newChosenSeason) {
        this.selectedSeason = newChosenSeason
        this.chosenRankingGroup = newChosenSeason.ranking_groups[newChosenSeason.ranking_groups.length - 1]
      }
    },
    chosenRankingGroup: {
      get: function () {
        return this.selectedRankingGroup
      },
      set: function (newRankingGroup) {
        this.selectedRankingGroup = newRankingGroup
      }
    },
    chosenRoster: {
      get: function () {
        return this.selectedRoster
      },
      set: function (newRoster) {
        this.$store.dispatch('invalidatedDetailedRoster')
        if (newRoster) {
          this.$store.dispatch('getDetailedRoster', newRoster.id)
          this.selectedRoster = newRoster
        }
      }
    },
    filteredRosterList: function () {
      if (this.selectedClub) {
        return store.getters.rosterListForClub(this.selectedClub.id)
      }
      return []
    },
    budgetStar: function () {
      if (this.rosteredStarPlayer === null) {
        return 0
      }
      return this.rosteredStarPlayer.cost
    },
    budgetAnnexe: function () {
      if (this.selectedRoster === null) {
        return 0
      }
      let budgetAnnexe = 0
      budgetAnnexe = this.nbRerolls * this.selectedRoster.reroll_price
      budgetAnnexe += this.apo * 50
      budgetAnnexe += (this.pop - 1) * 10
      budgetAnnexe += this.assistants * 10
      budgetAnnexe += this.pompoms * 10
      return budgetAnnexe
    },
    newlyHiredPlayers: function () {
      if (!this.$refs.teamBuilder) {
        return []
      } else {
        return this.$refs.teamBuilder.playerList
      }
    },
    hiredFormerPlayerRosterLines: function () {
      if (this.teamType !== 'franchise') {
        return []
      }
      if (!this.$store.getters.detailedTeam) {
        return []
      }
      if (!this.$refs.formerPlayerChooser) {
        return []
      }
      let hiredRl = []
      this.$store.getters.detailedRoster.roster_lines.forEach(rl => {
        hiredRl[rl.id] = 0
      })
      if (!this.$store.getters.detailedTeam) {
        return []
      }
      this.$store.getters.detailedTeam.players.forEach(p => {
        let found = this.$refs.formerPlayerChooser.playerToRevoke.find(ptr => {
          return p.id === ptr
        })
        // si le joueur n'est pas dans la liste des renvois, alors il est gardé, il faut donc ajouter 1 au roster line
        if (found === undefined) {
          let frl = this.$store.getters.detailedRoster.roster_lines.find(rl => {
            return rl.position === p.ref_roster_line
          })
          hiredRl[frl.id] = hiredRl[frl.id] + 1
        }
      })
      return hiredRl
    },
    freeAssistants: function () {
      return this.$refs.formerPlayerChooser.totalHiredPlayer
    },
    currentTeamBudget: function () {
      if (this.teamType !== 'franchise') {
        return this.totalPlayerCost + this.budgetAnnexe + this.budgetStar
      } else {
        return this.totalFormerPlayerCost + this.totalPlayerCost + this.budgetAnnexe + this.budgetStar
      }
    },
    totalPlayerCost () {
      return this.$refs.teamBuilder.totalPlayerCost
    },
    totalFormerPlayerCost () {
      return this.$refs.formerPlayerChooser.totalPlayerCost
    },
    maxBudget: function () {
      if (this.selectedSeason === null) {
        return null
      }
      let maxBudget = 0
      if (this.teamType === 'new' || this.teamType === 'newFranchise') {
        maxBudget = this.chosenSeason.starting_rules.max_budget
      }
      if (this.teamType === 'custom') {
        maxBudget = 10000
      }
      if (this.teamType === 'franchise') {
        // il faut caluler le budget de redémarrage
        if (this.$store.getters.seasonBreakInfos === null) {
          return null
        }
        let sbi = this.$store.getters.seasonBreakInfos
        maxBudget = sbi.restart_budget
      }
      return maxBudget
    }
  },
  created () {
    store.dispatch('getRosterList')
    store.dispatch('getUserList')
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
    store.dispatch('getClubList')
    store.dispatch('getLeagueList')
    this.$store.dispatch('invalidatedDetailedRoster')
    if (this.currentUser === null) {
      store.subscribe((mutation, state) => {
        if (mutation.type === 'setUser') {
          this.selectedCoach = this.currentUser
        }
      })
    } else {
      this.selectedCoach = this.currentUser
    }
  },
  methods: {
    updateFranchise (newSelectedFranchise) {
      this.selectedFranchise = newSelectedFranchise
      this.chosenRoster = null
      if (newSelectedFranchise) {
        this.teamName = newSelectedFranchise.name
        store.dispatch('invalidateDetailedTeam')
        store.dispatch('getSeasonBreakInfos', newSelectedFranchise.id)
        store.dispatch('getDetailedTeam', newSelectedFranchise.id.toString())
        this.chosenRoster = this.getRosterByName(newSelectedFranchise.ref_roster)
      }
    },
    goToDetail () {
      this.showMessage = false
      this.$router.push({name: 'TeamDetail', params: { id: this.createdTeamId }})
    },
    getRosterIcon (item) {
      return '/static/imgs/team-icons/' + item.ref_roster.name + '.png'
    },
    getRosterByName (rosterName) {
      return this.filteredRosterList.find(roster => {
        return roster.name === rosterName
      })
    },
    createTeam () {
      if (this.selectedRoster === null) {
        this.errorMsg = 'Il faut d\'abord choisir une équipe'
        return
      }
      if (this.teamName === '') {
        this.errorMsg = 'Le nom de la franchise est obligatoire !!'
        return
      }
      if (this.creationStarted === false) {
        this.creationStarted = true
      }
      if (this.currentTeamBudget > this.maxBudget) {
        this.errorMsg = 'On a dit ' + this.maxBudget + ' 000 de Budget d\'équipe, pas ' + this.currentTeamBudget + ' 000 !!'
        this.creationStarted = false
        return
      }
      this.showSpinner = true
      if (this.teamType === 'franchise') {
        this.postFranchise()
      } else if (this.teamType === 'newFranchise') {
        this.postNewFranchise()
      } else {
        this.postNewTeam()
      }
    },
    postFranchise () {
      // on va commencer par renvoyer les joueurs qui doivent l'etre, ainsi que tout l'encadrement
      let revokes = {}
      revokes.revoke = {}
      // gestion du stuff
      if (this.$store.getters.detailedTeam.apo) {
        revokes.revoke.apo = 1
      }
      if (this.$store.getters.detailedTeam.nb_rerolls > 0) {
        revokes.revoke.reroll = this.$store.getters.detailedTeam.nb_rerolls
      }
      if (this.$store.getters.detailedTeam.assistants > 0) {
        revokes.revoke.assistants = this.$store.getters.detailedTeam.assistants
      }
      if (this.$store.getters.detailedTeam.cheerleaders > 0) {
        revokes.revoke.cheerleaders = this.$store.getters.detailedTeam.cheerleaders
      }
      if (this.$store.getters.detailedTeam.rostered_star_player !== null) {
        revokes.revoke.star_player_player = {'id': this.$store.getters.detailedTeam.rostered_star_player.id}
      }
      let resmap = this.$refs.formerPlayerChooser.playerToRevoke.map(p => {
        return {'id': p}
      })
      revokes.revoke.players = resmap
      teamPurchases.api.publishTeamPurchases(this.$store.getters.detailedTeam.id, revokes)
        .then(response => {
          this.revokesDone = true
        },
        error => {
          console.log('erreur impossible to publish purchases')
          console.log(error)
        })
    },
    postNewTeam () {
      let createdTeam = {}
      if (this.apo === 1) {
        createdTeam.apo = true
      } else {
        createdTeam.apo = false
      }
      createdTeam.ref_roster = this.selectedRoster.id
      createdTeam.name = this.teamName
      createdTeam.initial_treasury = Math.max(this.chosenSeason.starting_rules.max_budget - this.currentTeamBudget, 0)
      createdTeam.nb_rerolls = this.nbRerolls
      createdTeam.pop = this.pop
      createdTeam.assistants = this.assistants
      createdTeam.cheerleaders = this.pompoms
      if (this.rosteredStarPlayer) {
        createdTeam.rostered_star_player = {}
        createdTeam.rostered_star_player.ref_star_player = this.rosteredStarPlayer.id
        createdTeam.rostered_star_player.num = 1
      }
      if (this.currentUser.is_superuser === true) {
        if (!this.selectedCoach) {
          this.errorMsg = 'Le coach n\'a pas été sélectionné !!'
          return
        }
        createdTeam.user = this.selectedCoach.id
      } else {
        createdTeam.user = this.currentUser.id
      }

      createdTeam.icon_file_path = this.$refs.imgEditor.currentImageSrc
      createdTeam.league = this.chosenSeason.id
      createdTeam.ranking_group = this.chosenRankingGroup.id
      createdTeam.DungeonBowl = false
      if (this.teamType === 'custom') {
        createdTeam.is_custom = true
      } else {
        createdTeam.is_custom = false
      }
      /**
       * pour chaque type de joueur enregistré, on crée les instances des joueurs en question à mettre dans l'équipe crée
       */
      createdTeam.players = this.$refs.teamBuilder.getPLayerArray()
      team.api.createTeam(createdTeam)
        .then(response => {
          this.showMessage = true
          this.creationStarted = false
          this.showSpinner = false
          this.createdTeamId = response.data['id']
        },
        error => {
          console.log('erreur impossible to create team')
          console.log(error)
          this.creationStarted = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

.starbox {
  margin-bottom: 0;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 1.3rem;
  font-weight: 400;
}

.inner-subtitle{
  text-align: left;
  font-size: 0.8rem;
  font-weight: 300;
  margin-bottom: 0.3rem
}



.roster tr td.action{
    padding: 0.4rem 0.3rem;
}

button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
}
.note {
    font-weight: 100;
    font-size: 0.8rem;
}
.error {
  color:#E7505A;
}

  .info {
    font-weight: 500;
  }

</style>



// WEBPACK FOOTER //
// team-create.vue?5ab63e8c